/******************************************************************************************
 *	Change Customer Reseller Controller
 ******************************************************************************************/
(function() {
  angular.module('rcControllers.changeCustomerReseller', []).controller(
    'ChangeCustomerResellerController',
    /* @ngInject */
    function(
      _,
      $log,
      $state,
      $stateParams,
      $scope,
      LicenseAdminSearchCriteria,
      LicenseAdminSearch,
      CurtainNotifications,
      SspList,
      Settings,
      User,
      SelectedCustomer,
      Customer,
      CustomerSegments,
      BreadcrumbsMenu,
      LicenseAdminSearchSnapshot
    ) {
      //Controls visibility of content area
      $scope.noData = true;

      /*=== Customer Details ===*/
      var customerID = $stateParams.customerID;
      $log.info('%cCustomer ID ::', 'font-weight:bold;color:#009966;', customerID);

      //Get Customer Details
      var getCustomer = function() {
        //Loading spinner on
        $scope.loadingData = true;

        Customer.getDetails(customerID)
          .then(function(responseData) {
            $scope.customer = responseData;

            //We have data
            $scope.noData = false;

            //Loading spinner off
            $scope.loadingData = false;
          })
          .catch(function(response) {
            $log.warn(response.data, response.status);

            if (response.status !== 0) {
              //status is 0 when call is aborted
              CurtainNotifications.show(
                CurtainNotifications.NOTICE,
                'customerDetails.notifications.invalidCustomer'
              );
              $scope.goToCustomerList();
            }
          });
      };

      if (SelectedCustomer.get() && SelectedCustomer.get().id === customerID) {
        $scope.customer = SelectedCustomer.get();
        $scope.noData = false;
      } else {
        getCustomer();
      }

      /*=== Current Reseller Details ===*/
      $scope.currentReseller = User.getReseller();

      /*=== Select New Reseller ===*/

      //Make search criteria available in view
      $scope.LicenseAdminSearchCriteria = LicenseAdminSearchCriteria;
      $scope.searchOptions = LicenseAdminSearchCriteria.getResellerOnlyOptions();
      // Use the resellers-only search instructions
      $scope.resellersOnly = true;

      $scope.showSearchResults = false; //Toggles search results table
      $scope.searchInProgress = false; //True when search is in progress, fales otherwise

      //Controls which results table is displayed.
      //There's are 2 tables: one for customers and one for resellers.
      //When set, a value from LICENSE_ADMIN_SEARCH_TYPES is assigned to it.
      $scope.searchType = null;

      //Search
      //Control vars for UI validation errors
      $scope.searchSubmitAttempted = false; //Was submit button clicked?

      var resetSearchSubmit = function() {
        $scope.searchSubmitted = false;
        $scope.searchSubmitAttempted = false;
      };

      $scope.submitSearch = function() {
        if (!$scope.searchSubmitted) {
          $scope.searchSubmitAttempted = true;

          if ($scope.searchForm.$valid) {
            $scope.searchSubmitted = true;
            $scope.searchInProgress = true;

            //Hide current search results table upon submit
            $scope.showSearchResults = false;

            //Structure data as needed by API
            var payload = {
              qField: $scope.searchCriteria.value,
              q: $scope.searchTerm
            };

            $log.info('%cLA search payload ::', 'font-weight:bold;color:#009966;', payload);

            //POST to service
            LicenseAdminSearch.get($scope.searchCriteria.searchType, payload)
              .then(function(responseData) {
                //Remove reseller orgs which have not accepted the invitation
                var filteredData;
                if (_.isArray(responseData)) {
                  filteredData = _.filter(responseData, function(resellerOrg) {
                    if (resellerOrg.active === true) {
                      //Tell view to hide action button for the reseller which is the same as the current user reseller
                      if (resellerOrg.id === $scope.currentReseller.id) {
                        resellerOrg.hideActionButton = true;
                      }

                      return true;
                    }
                    return false;
                  });
                }

                initSearchResults(filteredData);
                $scope.searchResultCount = responseData.length;
                $scope.noSearchData = false;
                $scope.showSearchResults = true;
              })
              .catch(function(response) {
                if (response.status !== 0) {
                  //status is 0 when call is aborted
                  if (
                    response.status === 400 &&
                    response.data.errorCode === 'INVALID_SEARCH_CRITERIA'
                  ) {
                    CurtainNotifications.show(
                      CurtainNotifications.ERROR,
                      'generic.notifications.error'
                    );
                  } else if (response.status === 404) {
                    $scope.searchErrorMessage = 'global.dataList.emptyMessages.noResultsFound';
                    $scope.noSearchData = true;
                    $scope.showSearchResults = true;
                  } else {
                    CurtainNotifications.show(
                      CurtainNotifications.ERROR,
                      'generic.notifications.error'
                    );
                  }
                }
                $log.error('Failed to perform search', response.data);
              })
              .finally(function() {
                //Tell the view what kind of search type is being performed
                //This is set after data is fetched so that the view doesn't change the table before new data is in.
                $scope.searchType = $scope.searchCriteria.searchType;

                //Allow new searches
                resetSearchSubmit();

                $scope.searchInProgress = false;
              });
          }
        }
      };

      //Team Members Data List init and refresh
      var searchResultsDataList;
      var refreshDataList = function(options) {
        $scope.searchResults = searchResultsDataList.get(options);
        if (!$scope.searchResults.data.length) {
          $scope.noSearchResults = true;
          $scope.searchErrorMessage = 'global.dataList.emptyMessages.noResultsFound';
        } else {
          $scope.noSearchResults = false;
        }
      };

      var initSearchResults = function(data) {
        searchResultsDataList = new SspList(data, {
          itemsPerPage: Settings.itemsPerPage.default
        });

        refreshDataList({page: 1});
      };

      //Pagination
      $scope.prevPage = function() {
        var page = $scope.searchResults.pagination.currentPage - 1;
        refreshDataList({page: page});
      };
      $scope.nextPage = function() {
        var page = $scope.searchResults.pagination.currentPage + 1;
        refreshDataList({page: page});
      };

      //Sorting
      $scope.sort = function(column, serverColumns, isNumeric) {
        refreshDataList({sortBy: column, sortNumeric: isNumeric});
      };

      //Search
      $scope.search = function(query) {
        refreshDataList({query: query});
      };
      $scope.clearSearch = function() {
        searchResultsDataList.clearSearch();
        refreshDataList();
      };

      /*=== Select Reseller ===*/

      //True when a new reseller is selected, false otherwise.
      //$scope.newReseller!==null could be used to determine this rendering this var useless
      //if it wasn't for animations.
      //If we tied view state to truthy-ness of $scope.newReseller, when this was null-ified
      //the transition would happen, but it would also trigger the watchers to update DOM
      //resulting in an ungly flicker.
      //Using newResellerSelected to control view state and not null-ifying newReseller allows
      //for a smooth animation
      $scope.newResellerSelected = false;

      $scope.resellerAction = function(event, reseller) {
        event.preventDefault();

        if (reseller.active && reseller.id !== $scope.currentReseller.id) {
          $scope.newResellerSelected = true;
          $scope.newReseller = reseller;
        }
      };

      /*=== Select Reseller ===*/

      //Cancel customer migration
      $scope.cancel = function() {
        $scope.newResellerSelected = false;
      };

      //Control vars for UI validation errors
      $scope.submitAttempted = false; //Was submit button clicked?

      var resetSubmit = function() {
        $scope.submitted = false;
      };

      //Ask JIL to migrate customer to selectedReseller
      $scope.submit = function() {
        //Careful: Must check if newResellerSelected is truthy first because newReseller is not
        //null-ified when cancelling new reseller selection (see $scope.cancel() function above).
        //Otherwise, a previous selection of newReseller would be sent to the server if somehow
        //the normally hidden submit button was pressed.
        if ($scope.newResellerSelected && $scope.newReseller) {
          $scope.submitted = true;

          Customer.migrateToNewReseller(customerID, $scope.newReseller.id)
            .then(function(responseData) {
              //Clear LicenseAdminSearchSnapshot because data there is stale now
              LicenseAdminSearchSnapshot.clear();

              //Navigate to the customer details page in the context of the new reseller
              $state.go('licenseAdmin.impersonatedReseller.customerDetails', {
                resellerID: responseData.resellerId,
                customerID: responseData.id
              });

              CurtainNotifications.show(
                CurtainNotifications.SUCCESS,
                'changeCustomerReseller.notifications.submitSuccess',
                {
                  customerName: $scope.customer.name,
                  resellerName: $scope.newReseller.name
                }
              );
            })
            .catch(function(response) {
              CurtainNotifications.show(CurtainNotifications.ERROR, 'generic.notifications.error');
              $log.error('Failed to migrate customer to new reseller', response.data);
            })
            .finally(() => resetSubmit());
        }
      };

      /*=== Breadcrumbs ===*/
      //Add customer ID for Customer Details link
      BreadcrumbsMenu.updateStateParams('licenseAdmin.impersonatedReseller.customerDetails', {
        customerID: customerID
      });

      //Navigation
      $scope.goToCustomerList = function() {
        $state.go('licenseAdmin.impersonatedReseller.customers.segments', {
          segment: CustomerSegments.getAllCustomersSegment()
        });
      };
      $scope.goBack = function() {
        $state.go('licenseAdmin.impersonatedReseller.customerDetails', {customerID: customerID});
      };
    }
  );
})();
